<script setup lang="ts">
import type { OrderItem } from "@/schemas/order";

defineProps<{ items: OrderItem[] }>();

const columns: TableColumn<OrderItem>[] = [
  { key: "name", label: "Produit" },
  { key: "quantity", label: "Quantité", mobileFullWidth: true, horizontalAlign: "right", verticalAlign: "middle" },
  { key: "subtotal", label: "Sous-total", mobileFullWidth: true, horizontalAlign: "right", verticalAlign: "middle" },
];
</script>

<template>
  <UiResponsiveTable :columns="columns" :data="items">
    <template #name-cell="{ row }">
      <ProductListItem v-if="row.product" :product="row.product" />
      <div v-else class="text-xl font-bold">
        {{ row.name }}
      </div>
    </template>
    <template #quantity-cell="{ row }">
      <div class="text-lg font-bold">
        ×{{ integer(row.quantity) }}
      </div>
    </template>
    <template #subtotal-cell="{ row }">
      <div class="text-xl font-medium text-primary">
        {{ currency(row.subtotal) }}
      </div>
    </template>
  </UiResponsiveTable>
</template>
